import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import WelcomePage from './components/WelcomePage';
import PublishingRoadmap from './components/PublishingRoadmap';
import PersonaSection from './components/PersonaSection';
import Quiz from './components/Quiz';
import BookPlanningChecklist from './components/BookPlanningChecklist';
import MarketingIntro from './components/MarketingIntro';
import NextSteps from './components/NextSteps';
import Navigation from './components/Navigation';
import './App.css';

function App() {
  const [quizResult, setQuizResult] = useState(null);

  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-emerald-50">
        <Navigation />
        <Routes>
          <Route path="/" element={<WelcomePage />} />
          <Route path="/roadmap" element={<PublishingRoadmap />} />
          <Route path="/persona/:type" element={<PersonaSection />} />
          <Route path="/quiz" element={<Quiz setQuizResult={setQuizResult} quizResult={quizResult} />} />
          <Route path="/checklist" element={<BookPlanningChecklist />} />
          <Route path="/marketing" element={<MarketingIntro />} />
          <Route path="/next-steps" element={<NextSteps />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;